import { useAuth } from "@/contexts/AuthContext";
import { Globe } from "lucide-react";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";
import { EnablePushButton } from "@/components/EnablePushButton";

export default function Tetapan() {
  const { user } = useAuth();

  return (
    <div className="p-6 sm:p-10 max-w-xl" data-testid="member-tetapan-page">
      <h1 className="font-display text-xl font-bold text-piks-black mb-6">Tetapan</h1>
      <div className="p-6 rounded-xl bg-white border border-piks-border mb-5">
        <p className="text-xs text-piks-muted mb-1">Nama</p>
        <p className="font-semibold text-piks-black mb-4">{user?.name}</p>
        <p className="text-xs text-piks-muted mb-1">Emel</p>
        <p className="font-semibold text-piks-black">{user?.email}</p>
      </div>
      <div className="p-6 rounded-xl bg-white border border-piks-border mb-5">
        <p className="text-sm font-semibold text-piks-black mb-1">Keselamatan Akaun</p>
        <p className="text-xs text-piks-muted mb-4">Tukar kata laluan akaun anda dari semasa ke semasa untuk keselamatan.</p>
        <ChangePasswordDialog triggerClassName="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold bg-piks-black text-white hover:bg-piks-black/90" />
      </div>
      <div className="p-6 rounded-xl bg-white border border-piks-border mb-5" data-testid="push-notification-section">
        <p className="text-sm font-semibold text-piks-black mb-1">Notifikasi</p>
        <p className="text-xs text-piks-muted mb-4">Aktifkan notifikasi push untuk menerima kemas kini status keahlian terus ke peranti anda.</p>
        <EnablePushButton />
      </div>
      <div className="flex items-center gap-3 p-4 rounded-lg bg-piks-ivory border border-dashed border-piks-border text-piks-muted">
        <Globe className="w-4 h-4" />
        <p className="text-sm">Sokongan Bahasa Inggeris — Akan Datang</p>
      </div>
    </div>
  );
}
